import { useTranslation } from "react-i18next";
import { PARTNER_LOGOS } from "@/lib/content";

// Resilient image: falls back to a small text badge when the CDN fails.
const LogoImg = ({ name, src, className }) => {
  const handleErr = (e) => {
    const img = e.currentTarget;
    if (img.dataset.fb) return;
    img.dataset.fb = "1";
    const span = document.createElement("span");
    span.className = "text-xs font-bold uppercase tracking-[0.18em] text-slate-400 px-2 whitespace-nowrap";
    span.textContent = name;
    img.replaceWith(span);
  };
  return (
    <img
      src={src}
      alt={`${name} logo`}
      loading="lazy"
      decoding="async"
      width="120"
      height="28"
      onError={handleErr}
      referrerPolicy="no-referrer"
      className={className}
    />
  );
};

export const PartnerMarquee = () => {
  const { t } = useTranslation();
  const items = [...PARTNER_LOGOS, ...PARTNER_LOGOS];
  return (
    <section
      data-testid="partner-logos-marquee"
      aria-label="Platform partners"
      className="relative overflow-hidden border-y border-slate-200 bg-white"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-white to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-white to-transparent" />
      <div className="dc-marquee-track flex w-max items-center gap-12 py-7">
        {items.map((p, idx) => (
          <LogoImg
            key={`${p.name}-${idx}`}
            name={p.name}
            src={p.src}
            className="h-6 w-auto shrink-0 opacity-70 grayscale transition-all duration-200 hover:opacity-100 hover:grayscale-0 sm:h-7"
          />
        ))}
      </div>
      <p className="pb-5 text-center text-xs text-slate-500">
        {t("sections.partners.caption")}
      </p>
    </section>
  );
};
